import { Controller } from "stimulus"

export default class extends Controller {

    static targets= ["acceptCourse", "courseReject", "courseTick", "acceptPlan", "planReject", "planTick", "courseReason", "planReason"]

    connect () {
        this.menteesSubmit = document.getElementById("mentees-submit")
        this.spCheckboxes = document.querySelectorAll(".sp-checkbox")
        this.spCheckboxes.forEach(cb => {
            cb.addEventListener("change", () => this.updateSubmitState())
        })
        if (this.hasAcceptPlanTarget) {
            if (this.acceptPlanTarget.value == 'false' ) {
                this.rejectPlan()
            }
        }
        if (this.hasAcceptCourseTarget) {
            if (this.acceptCourseTarget.value == 'false') {
                this.rejectCourse()
            } 
        }
        if (!this.hasAcceptCourseTarget && !this.hasAcceptPlanTarget) {
            this.updateSubmitState()
        }
    }

    allStatementsChecked() {
        return [...this.spCheckboxes].every(cb => cb.checked)
    }
    updateSubmitState() {
        const planOk = !this.hasAcceptPlanTarget || this.acceptPlanTarget.value == 'true'
        const courseOk = !this.hasAcceptCourseTarget || this.acceptCourseTarget.value == 'true'
        this.menteesSubmit.disabled = !(this.allStatementsChecked() && planOk && courseOk)
    }

    approveCourse() {
        this.acceptCourseTarget.value = true
        this.courseTickTarget.style.display = "inline-block"
        this.courseRejectTarget.classList.add("hide", "fade")
        this.courseReasonTarget.value = ""
        this.updateSubmitState()
    }

    rejectCourse() {
        this.acceptCourseTarget.value = false
        this.courseTickTarget.style.display = "none"
        this.courseRejectTarget.classList.remove("hide", "fade")
        this.updateSubmitState()
    }

    approvePlan(){        
        this.acceptPlanTarget.value = true
        this.planTickTarget.style.display = "inline-block"
        this.planRejectTarget.classList.add("hide", "fade")
        this.planReasonTarget.value = ""
        this.updateSubmitState()
    }

    rejectPlan() {
        this.acceptPlanTarget.value = false
        this.planTickTarget.style.display = "none"
        this.planRejectTarget.classList.remove("hide", "fade")
        this.updateSubmitState()
    }
}